import React from 'react';
import { OrgGeneralSettings } from './OrgGeneralSettings';
import { OrgLogo } from './OrgLogo';

export function OrgSettings() {
  return (
    <>
      <OrgGeneralSettings />
      <OrgLogo />
    </>
  );
}
